function headerNav() {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const targetElement = document.querySelector(this.getAttribute("href"));
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: "smooth",
        });

        // Also close the mobile menu if it is open
        const mobileMenuInput: HTMLInputElement | null = document.querySelector(
          "#mobile-menu-trigger"
        );
        if (mobileMenuInput) mobileMenuInput.checked = false;
      }
    });
  });
}

const main = async () => {
  headerNav();
};

main();
